/**
 * Componente de carga simple
 */

export function LoadingSpinner() {
  return (
    <div className="loading-spinner" role="status" aria-label="Cargando">
      <span className="sr-only">Cargando...</span>
      <div className="spinner" />
    </div>
  );
}

